import { ButtonBase, Link, Text } from '@stitch-fix/mode-react';
import { SignInMachineContext } from '../../machines/sign-in/SignInMachineContext';
import { SocialButtons } from '../SocialButtons';
import {
  eraseDynamicAdsCookie,
  getDynamicAdsCookie,
  useDynamicProductAdCreate,
} from '../../features/dynamicAds/utils/useDynamicProductAdCreate';

export const SignInFormFooter = () => {
  const [state, send] = SignInMachineContext.useActor();
  const dynamicProductAdCreate = useDynamicProductAdCreate();

  return (
    <>
      <SocialButtons
        mode="login"
        onLogin={async params => {
          const dpaCookie = getDynamicAdsCookie();

          if (dpaCookie) {
            await dynamicProductAdCreate({
              clientType: 'login',
              variables: {
                input: {
                  id: dpaCookie.id,
                  grouping: dpaCookie.grouping,
                },
              },
            });

            eraseDynamicAdsCookie();
          }
          send({
            type: 'LOGIN_SUCCESS',
            redirectUrl: params.redirect_url,
          });
        }}
        onError={error =>
          send({
            type: 'SSO_LOGIN_FAILURE',
            error,
            isWafEnabled: state.context.isWafEnabled,
          })
        }
        isWafEnabled={state.context.isWafEnabled}
      />

      <Text setting="body-small" align="center" my={2}>
        Don&apos;t have an account?&nbsp;
        <Link as={ButtonBase} onClick={() => send('REDIRECT_TO_SIGNUP')}>
          Sign up
        </Link>
      </Text>
    </>
  );
};
